import angular from 'angular';
import config from 'app/config';
import template from './addtocalendar.tpl.html';
import 'app/common/styles/_addtocalendar.scss';
import { ICalendar, GoogleCalendar, OutlookCalendar } from 'datebook';
import moment from "moment";
import 'moment-timezone';

class AddToCalendarController {
  constructor($rootScope, $attrs) {
    this.page = $rootScope.page;
    this.config = config;
    this.$attrs = $attrs;
  }

  $onInit() {
    this.datetime = this.$attrs.datetime || this.page.options.webinar.datetime;
    this.type = this.$attrs.type || 'default';
    this.eventdate = moment.tz(this.datetime, this.$attrs.timezone || 'America/New_York');
    this.day = this.eventdate.format('D');
    this.dayofweek = this.eventdate.format('dddd');

    if (this.$attrs.url) {
      this.location = this.$attrs.url;
    }

    if (this.$attrs.desc) {
      this.description = this.$attrs.desc;
    }

    this.calconfig = {
      title: this.$attrs.subject || "New Event",
      location: this.location,
      description: this.description,
      start: moment(this.eventdate).toDate(),
      end: moment(this.eventdate).add(this.$attrs.duration || 90, 'minutes').toDate(),
      attendees: false,
    }

    if (this.$attrs.allday) {
      delete this.calconfig.end;
    }

    // an event that recurs every count:
    if (this.$attrs.count) {
      this.calconfig.recurrence = {
        frequency: this.$attrs.frequency || 'DAILY',
        interval: this.$attrs.interval || 1,
        count: this.$attrs.count
      }
    }
    this.icalendar = new ICalendar(this.calconfig);
    this.googleCalendar = new GoogleCalendar(this.calconfig);
    this.outlookCalendar = new OutlookCalendar(this.calconfig);
  }

  downloadiCal() {
    this.dataBlob = new Blob([this.icalendar.render()], {
      type: 'text/calendar'
    })
    var urlObject = URL.createObjectURL(this.dataBlob);
    var downloadLink = angular.element('<a>iCal</a>');
    downloadLink.css('display', 'none');
    downloadLink.attr('href', urlObject);
    downloadLink.attr('download', 'ical-event.ics');
    angular.element(document.body).append(downloadLink);
    downloadLink[0].click();
    // cleanup
    downloadLink.remove();
    URL.revokeObjectURL(urlObject);
  }

}

AddToCalendarController.$inject = ['$rootScope', '$attrs'];

class AddToCalendarDirective {

  constructor() {
    this.restrict = "EAC";
    this.scope = {
      type: '@?',
    };
    this.template = template;
    this.controller = AddToCalendarController;
    this.controllerAs = '$ctrld';
    // this.page = $rootScope.page;
  }

  link(scope, element, attrs, ctrl) {
  }

  static directiveFactory() {
    return new AddToCalendarDirective();
  }
}

export default angular
  .module('addToCalendar.directive', [])
  .directive('addToCalendar', AddToCalendarDirective.directiveFactory)
  .name;